var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.7422 14.621H30.5001V16.3788H28.7422V14.621Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7422 5.88818H30.5001V7.64599H28.7422V5.88818Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.168 0.5H23.9259V2.25781H22.168V0.5Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8844 9.24051C21.0219 8.36091 19.9797 7.65819 18.8178 7.19249V2.25781H20.7016V0.5H17.0599V6.69082C16.5532 6.60134 16.0318 6.55459 15.4998 6.55459C14.9677 6.55459 14.4464 6.60134 13.9396 6.69082V0.5H10.298V2.25781H12.1818V7.19249C11.02 7.65819 9.97769 8.36096 9.11519 9.24051L6.02228 5.88814H3.72266V7.64595H5.25236L8.00186 10.6261C7.2378 11.7975 6.74069 13.1581 6.59737 14.621H3.72266V16.3788H6.59737C6.74069 17.8416 7.2378 19.2022 8.00186 20.3736L5.25236 23.3538H3.72266V25.1116H6.02228L9.11519 21.7592C9.97769 22.6388 11.02 23.3415 12.1818 23.8072V28.7419H10.298V30.4997H13.9396V24.3089C14.4464 24.3984 14.9677 24.4451 15.4998 24.4451C16.0318 24.4451 16.5532 24.3984 17.0599 24.3089V30.4998H20.7016V28.742H18.8178V23.8073C19.9796 23.3416 21.0218 22.6389 21.8843 21.7593L24.9773 25.1117H27.2768V23.3539H25.7471L22.9976 20.3738C23.7617 19.2023 24.2589 17.8417 24.4022 16.3788H27.2768V14.621H24.4022C24.2589 13.1582 23.7617 11.7976 22.9977 10.6262L25.7472 7.64601H27.2768V5.8882H24.9772L21.8844 9.24051ZM14.6209 11.0992H16.3787V14.8236H14.6209V11.0992ZM15.4998 20.1935C12.9417 20.1935 10.8606 18.1123 10.8606 15.5543C10.8606 14.2811 11.3931 13.0499 12.3217 12.176L13.5263 13.4561C12.9408 14.0072 12.6184 14.7523 12.6184 15.5543C12.6184 17.1431 13.911 18.4357 15.4998 18.4357C17.0886 18.4357 18.3812 17.1431 18.3812 15.5543C18.3812 14.7523 18.0588 14.0072 17.4733 13.4561L18.678 12.176C19.6065 13.0499 20.1391 14.2812 20.1391 15.5543C20.139 18.1123 18.0579 20.1935 15.4998 20.1935Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7422 23.3539H30.5001V25.1117H28.7422V23.3539Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.168 28.7419H23.9259V30.4997H22.168V28.7419Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 14.621H2.25792V16.3788H0.5V14.621Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.88818H2.25792V7.64599H0.5V5.88818Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07422 0.5H8.83214V2.25781H7.07422V0.5Z",
    fill: "white"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 23.3539H2.25792V25.1117H0.5V23.3539Z",
    fill: "white"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M7.07422 28.7419H8.83214V30.4997H7.07422V28.7419Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup);
export default __webpack_public_path__ + "static/media/Group.47bcbb86cb8e0a2f89ec17e84603e50a.svg";
export { ForwardRef as ReactComponent };